import { useTheme } from '@mui/material/styles';
import { AppTheme } from '../theme';

export default function useAppTheme() {
  return useTheme<AppTheme>();
}
